<template>
  <div class="pedido-listado">
    <section class="pedido-steps" v-if="!mostrar_detalle">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="return d-block d-sm-none">
              <router-link :to="route">
                <img :src="require('@/assets/img/backspace.svg')" class="mb-5">
              </router-link>
            </div>
            <div class="section-title">
              <h5 class="pull-left">Listado de los cuotas.</h5>
              <router-link :to="route">
                <img class="d-none d-sm-block" :src="require('@/assets/img/backspace.svg')">
              </router-link>
            </div>
          </div>
        </div>
        <form class="form-filter">
          <div class="row">
            <div v-if="this.country === 'Argentina'" class="col-md-6">
              <div class="form-group">
                <label>Región</label>
                <VueMultiselect
                    v-model="filter.selectedZone"
                    :options="zoneOptions"
                    :close-on-select="true"
                    :clear-on-select="false"
                    placeholder="Select one"
                    :loading="loadingZone"
                    label="displayText"
                    @select="handleSelectChange"
                    @remove="unselectZone"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>SKU</label>
                <VueMultiselect
                    v-model="filter.selectedSku"
                    :options="skuOptions"
                    :close-on-select="true"
                    :clear-on-select="false"
                    placeholder="Select one"
                    :loading="loadingSku"
                    :disabled="(this.country === 'Argentina' && !filter.selectedZone) || loading"
                    label="displayText"
                />
              </div>
            </div>
            <div v-if="this.country === 'Calatin' || this.country === 'Argentina'" class="col-md-6">
              <div class="form-group">
                <label>Cliente</label>
                <VueMultiselect
                    v-model="filter.selectedClient"
                    :options="clientOptions"
                    :close-on-select="true"
                    :clear-on-select="false"
                    placeholder="Select one"
                    :loading="loadingClient"
                    :disabled="(this.country === 'Argentina' && !filter.selectedZone) || loading"
                    label="displayText"
                />
              </div>
            </div>
            <div v-if="this.country === 'Calatin'" class="col-md-6">
              <div class="form-group">
                <label>Planta</label>
                <VueMultiselect
                    v-model="filter.selectedPlant"
                    :options="plantOptions"
                    :close-on-select="true"
                    :clear-on-select="false"
                    placeholder="Select one"
                    :loading="loadingPlant"
                    label="displayText"
                />
              </div>
            </div>
            <div v-if="this.country === 'Mexico'" class="col-md-6">
              <div class="form-group">
                <label>Channel</label>
                <VueMultiselect
                    v-model="filter.selectedZone"
                    :options="zoneOptions"
                    :close-on-select="true"
                    :clear-on-select="false"
                    placeholder="Select one"
                    :loading="loadingZone"
                    label="displayText"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Fecha Inicio</label>
                <Datepicker
                    v-model="filter.start_date"
                    name="start-date"
                    :enableTimePicker="false"
                    textInput
                    autoApply
                    format="dd/MM/yyyy"
                    inputClassName="dp-input-custom"
                    required
                    utc="preserve"
                    @internal-model-change="handleZoneData"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Fecha Final</label>
                <Datepicker
                    v-model="filter.final_date"
                    name="final-date"
                    :enableTimePicker="false"
                    textInput
                    autoApply
                    format="dd/MM/yyyy"
                    inputClassName="dp-input-custom"
                    required
                    utc="preserve"
                    @internal-model-change="handleZoneData"
                />
              </div>
            </div>
            <div class="col-md-3" v-if="country === 'Argentina'">
              <!-- Show the input form once loading is done -->
              <div class="form-group" id="_availability_quantity">
                <label>Disponible Zona</label>
                <div v-if="loadingAvailable" class="loading-container">
                  <div class="spinner"></div>
                </div>
                <div v-else>
                  <input type="text" id="disponible_zona" name="disponible_zona"
                         v-model="disponible_zona" disabled>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- Espaciado para dispositivos grandes y medianos -->
            <div class="col-md-8 d-none d-md-block">&nbsp;</div>

            <!-- Botones para dispositivos grandes y medianos -->
            <div class="col-md-4 next-btn d-none d-md-block">
              <a href="javascript:void(0)" @click="getCuotas()" class="btn-green">Buscar</a>
              <a href="javascript:void(0)" @click="cleanFilter" class="btn-white">Limpiar</a>
            </div>

            <!-- Botones para dispositivos pequeños -->
            <div style="width: 100%;">
              <div class="col-12 next-btn d-block d-md-none mb-3">
                <a href="javascript:void(0)" @click="getCuotas()" class="btn-green"
                   style="margin-right: auto; margin-left: auto;">Buscar</a>
              </div>

              <div class="col-12 next-btn d-block d-md-none mb-3">
                <a href="javascript:void(0)" @click="cleanFilter" class="btn-white"
                   style="margin-right: auto; margin-left: auto;">Limpiar</a>
              </div>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-12">
            <div class="confirmado mt-2">
              <!--Para desktop-->
              <table class="bg-white d-none d-sm-table" id="pedidosTable">
                <thead>
                <tr style="background-color: #fffadc;">
                  <th class="text-center" v-if="this.country === 'Calatin' || this.country === 'Mexico'">
                    SKU
                    <Tooltip :parent="'skus'" :message="'Número de identificación interno Mccain.'">(?)</Tooltip>
                  </th>
                  <th class="text-center" v-if="this.country === 'Argentina'">SKU
                    <Tooltip :parent="'skus'" :message="'Número de identificación interno Mccain.'">(?)</Tooltip>
                  </th>
                  <th class="text-center" v-if="this.country === 'Calatin'">Cliente
                    <Tooltip :parent="'client'" :message="'Cliente distribuidor de Mccain.'">(?)</Tooltip>
                  </th>
                  <th class="text-center" v-if="this.country === 'Argentina'">Cliente
                    <Tooltip :parent="'client'" :message="'Cliente distribuidor de Mccain.'">(?)</Tooltip>
                  </th>
                  <th class="text-center" v-if="this.country === 'Argentina'">Región
                    <Tooltip :parent="'client'" :message="'Cliente distribuidor de Mccain.'">(?)</Tooltip>
                  </th>
                  <th class="text-center" v-if="this.country === 'Argentina'">Vendedor
                    <Tooltip :parent="'client'" :message="'Cliente distribuidor de Mccain.'">(?)</Tooltip>
                  </th>
                  <th class="text-center" v-if="this.country === 'Calatin'">Planta
                    <Tooltip :parent="'plant_id'" :message="'Número de planta de Mccain.'">(?)</Tooltip>
                  </th>
                  <th class="text-center" v-if="this.country === 'Mexico'">Channel
                    <Tooltip :parent="'channel'" :message="'Canal de Venta en Mccain.'">(?)</Tooltip>
                  </th>
                  <th class="text-center" v-if="this.country === 'Calatin' || this.country === 'Mexico'">
                    Cantidad
                    <Tooltip :parent="'distribuidores'" :message="'Cantidad de cuota.'">(?)</Tooltip>
                  </th>
                  <th class="text-center" v-if="this.country === 'Calatin' || this.country === 'Mexico'">
                    Disponible
                    <Tooltip :parent="'source'" :message="'Disponible para compra.'">(?)</Tooltip>
                  </th>
                  <th class="text-center" v-if="this.country === 'Argentina'">Cantidad
                    <Tooltip :parent="'distribuidores'" :message="'Cantidad de cuota.'">(?)</Tooltip>
                  </th>
                  <th class="text-center" v-if="this.country === 'Argentina'">Disponible
                    <Tooltip :parent="'source'" :message="'Disponible para compra.'">(?)</Tooltip>
                  </th>
                  <th class="text-center">Fecha Inicio
                    <Tooltip :parent="'start_date'" :message="'Fecha de inicio de la cuota'">(?)</Tooltip>
                  </th>
                  <th class="text-center">Fecha Final
                    <Tooltip :parent="'final_date'" :message="'Fecha de finalizacion de la cuota.'">(?)</Tooltip>
                  </th>
                  <th class="text-center">Acciones
                    <Tooltip :parent="'actions'" :message="'Detalle de la cuota.'">(?)</Tooltip>
                  </th>
                </tr>
                </thead>
                <tbody id="mostrarTablas">
                <tr class="b-top cuota-row" v-for="(cuota,index) in this.items" :key="index" @click="verCuota(cuota)">
                  <td class="text-center" v-if="this.country === 'Argentina'">{{ cuota.SKU }}</td>
                  <td class="text-center" v-if="this.country === 'Calatin'">{{ cuota.sku }}</td>
                  <td class="text-center" v-if="this.country === 'Mexico'">{{ cuota.sap }}</td>
                  <td class="text-center" v-if="this.country === 'Argentina'">{{ cuota.cliente }}</td>
                  <td class="text-center" v-if="this.country === 'Argentina'">{{ cuota.zona_nombre }}</td>
                  <td class="text-center" v-if="this.country === 'Argentina'">{{ cuota.vendedor }}</td>
                  <td class="text-center" v-if="this.country === 'Calatin'">{{ cuota.sold_to }}</td>
                  <td class="text-center" v-if="this.country === 'Calatin'">{{ cuota.plant_id }}</td>
                  <td class="text-center" v-if="this.country === 'Mexico'">{{ cuota.zone }}</td>
                  <td class="text-center" v-if="this.country === 'Argentina'">{{ cuota.Cajas }}</td>
                  <td class="text-center" v-if="this.country === 'Argentina'">{{ cuota.disponible }}</td>
                  <td class="text-center" v-if="this.country === 'Calatin' || this.country === 'Mexico'">
                    {{ cuota.quantity }}
                  </td>
                  <td class="text-center" v-if="this.country === 'Calatin' || this.country === 'Mexico'">
                    {{ cuota.availability }}
                  </td>
                  <td class="text-center">{{ cuota.start_date }}</td>
                  <td class="text-center">{{ cuota.final_date }}</td>
                  <td class="text-center">
                    <div class="inline-flex">
                      <img class="mr-2 ml-2 pointer" @click="verCuota(cuota)" src="assets/img/more.svg">
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>

              <!--Para mobile hay que hacer una tabla por pedido-->
              <table class="bg-white d-block d-sm-none pedidosTableMobile b-top cuota-row"
                     v-for="(cuota,index) in this.items" :key="index" @click="verCuota(cuota)">
                <tr>
                  <th class="text-center">SKU</th>
                  <td class="text-center" v-if="this.country === 'Argentina'">{{ cuota.SKU }}</td>
                  <td class="text-center" v-if="this.country === 'Calatin'">{{ cuota.sku }}</td>
                  <td class="text-center" v-if="this.country === 'Mexico'">{{ cuota.sap }}</td>
                </tr>
                <tr v-if="this.country === 'Argentina'">
                  <th class="text-center">Cliente</th>
                  <td class="text-center">{{ cuota.cliente }}</td>
                </tr>
                <tr v-if="this.country === 'Argentina'">
                  <th class="text-center">Región</th>
                  <td class="text-center">{{ cuota.zona_nombre }}</td>
                </tr>
                <tr v-if="this.country === 'Argentina'">
                  <th class="text-center">Vendedor</th>
                  <td class="text-center">{{ cuota.vendedor }}</td>
                </tr>
                <tr v-if="this.country === 'Calatin'">
                  <th class="text-center">Cliente</th>
                  <td class="text-center">{{ cuota.sold_to }}</td>
                </tr>
                <tr v-if="this.country === 'Calatin'">
                  <th class="text-center">Planta</th>
                  <td class="text-center">{{ cuota.plant_id }}</td>
                </tr>
                <tr v-if="this.country === 'Mexico'">
                  <th class="text-center">Channel</th>
                  <td class="text-center">{{ cuota.zone }}</td>
                </tr>
                <tr>
                  <th class="text-center">Cantidad</th>
                  <td class="text-center" v-if="this.country === 'Calatin' || this.country === 'Mexico'">
                    {{ cuota.quantity }}
                  </td>
                  <td class="text-center" v-if="this.country === 'Argentina'">{{ cuota.Cajas }}</td>
                </tr>
                <tr>
                  <th class="text-center">Disponible</th>
                  <td class="text-center" v-if="this.country === 'Calatin' || this.country === 'Mexico'">
                    {{ cuota.availability }}
                  </td>
                  <td class="text-center" v-if="this.country === 'Argentina'">
                    {{ cuota.disponible }}
                  </td>
                </tr>
                <tr>
                  <th class="text-center">Fecha de Inicio</th>
                  <td class="text-center">{{ cuota.start_date }}</td>
                </tr>
                <tr>
                  <th class="text-center">Fecha Final</th>
                  <td class="text-center">{{ cuota.final_date }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="loading d-none"></div>
        <div class="row">
          <div class="col-md-12 text-center mb-5">
            <Vue3BsPaginate
                :total="total"
                v-model="currentPage"
                :perPage=perPage
                alignment="center"
            />
          </div>
        </div>
        <div class="row">
          <!-- Botones para dispositivos grandes y medianos -->
          <div class="col-md-12 next-btn d-none d-md-block">
            <a href="javascript:void(0)" @click="newCuota" class="btn-green">Nuevo</a>
            <a href="javascript:void(0)" @click="exportXlsx" class="btn-green">Descargar</a>
            <a href="javascript:void(0)" @click="openFileUploader" class="btn-white">Importar</a>
            <a href="javascript:void(0)" @click="exportReport" class="btn-green"
               v-if="this.country === 'Argentina' && this.admin_cuota">Reporte</a>
          </div>

          <!-- Botones para dispositivos pequeños -->
          <div class="col-12 next-btn d-block d-md-none mb-3">
            <a href="javascript:void(0)" @click="newCuota" class="btn-green"
               style="margin-right: auto; margin-left: auto;">Nuevo</a>
          </div>

          <div class="col-12 next-btn d-block d-md-none mb-3">
            <a href="javascript:void(0)" @click="exportXlsx" class="btn-green"
               style="margin-right: auto; margin-left: auto;">Descargar</a>
          </div>

          <div class="col-12 next-btn d-block d-md-none mb-3">
            <a href="javascript:void(0)" @click="openFileUploader" class="btn-white"
               style="margin-right: auto; margin-left: auto;">Importar</a>
          </div>

          <div class="col-12 next-btn d-block d-md-none mb-3">
            <a href="javascript:void(0)" @click="exportReport" class="btn-green"
               style="margin-right: auto; margin-left: auto;" v-if="this.country === 'Argentina' && this.admin_cuota">Reporte</a>
          </div>
        </div>

        <form novalidate @submit.prevent="onSubmit">
          <file-upload id="fileupload" v-model="form.file" @change="importXlsx" style="display: none;"></file-upload>
        </form>
      </div>
    </section>
    <CuotaDetalle v-if="mostrar_detalle"
                  :country="this.country"
                  :selectedCuota="this.selectedCuota"
                  @ocultarDetalle="ocultarDetalle"
                  @updateCuota="updateCuota"
    ></CuotaDetalle>
    <vue-basic-alert :duration="300" :closeIn="1000000" ref="alert"/>
  </div>
</template>

<script>
import {route} from '@/enviroment';
import axios from 'axios';
import $ from 'jquery';
import {Vue3BsPaginate} from 'vue3-bootstrap-paginate';
import FileUpload from '../../snippets/FileUpload.vue';
import Tooltip from '../../snippets/Tooltip.vue';
import CuotaDetalle from '../cuotas/CuotaDetalle.vue';

export default {
  name: 'CuotaListado',
  components: {
    Vue3BsPaginate, Tooltip, FileUpload, CuotaDetalle
  },
  data: function () {
    return {
      country: '',
      perPage: 10,
      currentPage: 1,
      cuotas: [],
      route: route,
      admin_cuota: false,
      filterData: {
        skus: [],
        clients: [],
        plants: [],
        zones: []
      },
      selectedClient: null,
      clientOptions: [],
      selectedSku: null,
      skuOptions: [],
      selectedPlant: null,
      plantOptions: [],
      selectedZone: null,
      zoneOptions: [],
      filter: {
        selectedSku: null,
        selectedClient: null,
        selectedZone: null,
        selectedPlant: null,
        start_date: null,
        final_date: null
      },
      form: {
        file: null
      },
      selectedCuota: Object,
      mostrar_detalle: false,
      disponible_zona: '',
      loadingAvailable: false,
      loadingSKU: false,
      loadingClient: false,
      loadingZone: false,
      loadingPlant: false,
    }
  },
  computed: {
    total() {
      return this.cuotas.length
    },
    items() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
      return this.cuotas.slice(startIndex, endIndex);
    },
  },
  async created() {
    await this.getUser();
    this.getCuotas();
    if (this.country === 'Mexico') {
      this.getSkus();
      this.getZones();
    }
    if (this.country === 'Calatin') {
      this.getSkus();
      this.getClients();
      this.getPlants();
    }
    if (this.country === 'Argentina') {
      this.getZones();
    }
  },
  mounted() {
    this.mostrarCarga();
    // try {
    //   const profile = sessionStorage.getItem('mccain_cuotas_user');
    //   if (profile) {
    //     const data = JSON.parse(profile);
    //
    //     // Check if address exists and countryName is available
    //     if (data.address && data.address.countryName) {
    //       if (data.address.countryName.toString().toLowerCase() === 'argentina') {
    //         const today = new Date();
    //         this.filter.start_date = new Date(today.getFullYear(), today.getMonth(), 1);
    //         this.filter.final_date = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    //       }
    //     }
    //   }
    // } catch (error) {
    //   console.error('Error retrieving profile data:', error);
    // }
  },
  watch: {
    'filter.selectedSku': function (element) {
      console.log(element)
      this.disponible_zona = '';
      this.filter.prev_start_date = null;
      this.filter.prev_final_date = null;
      this.handleZoneData();
    },
  },
  methods: {
    async handleSelectChange() {
      if (this.country === 'Argentina') {
        this.filter.selectedSku = null;
        this.disponible_zona = '';
        this.filter.prev_start_date = null;
        this.filter.prev_final_date = null;
        this.getSkus();
        this.getClients();
      }
    },
    unselectZone() {
      this.filter.selectedSku = null;
      this.disponible_zona = '';
      this.filter.prev_start_date = null;
      this.filter.prev_final_date = null;
    },
    handleZoneData() {
      if (this.country === 'Argentina') {
        if (!this.filter.selectedZone || !this.filter.selectedSku || !this.filter.start_date || !this.filter.final_date) {
          this.disponible_zona = '';
          this.filter.prev_start_date = null;
          this.filter.prev_final_date = null;
        }
        if (this.filter.selectedZone && this.filter.selectedSku && this.filter.start_date && this.filter.final_date &&
            (this.filter.start_date !== this.filter.prev_start_date ||
                this.filter.final_date !== this.filter.prev_final_date)
        ) {
          const index = this.filterData.skus.findIndex((s) => s.code === this.filter.selectedSku.value);
          if (index >= 0) {
            const sku = this.filterData.skus[index];
            const selectedEAN = sku.code ?? '';
            const selectedSku = sku.material ?? '';
            let data = {
              'selectedZone': this.filter.selectedZone?.value?.zona_nombre,
              'selectedEAN': selectedEAN,
              'selectedSku': selectedSku,
              'start_date': (new Date(this.filter.start_date)).toISOString().split('T')[0],
              'final_date': (new Date(this.filter.final_date)).toISOString().split('T')[0]
            }
            this.disponible_zona = '';
            this.loadingAvailable = true;
            this.filter.prev_start_date = this.filter.start_date;
            this.filter.prev_final_date = this.filter.final_date;
            axios.post(`/cuotificador/zones/quotation`, data)
                .then(async (res) => {
                  if (res.status === 200 && res.data.status === 'success') return res.data.data;
                  else throw new Error(res.data.message);
                })
                .then(async (data) => {
                  if (data.status.toString() === 'error') throw new Error(data.message);
                  if (data.zones.length > 0) this.disponible_zona = data.zones[0].disponible_zona ?? '';
                })
                .catch((error) => {
                  let msg = '';
                  if (error.status && error.status === 200) msg = error.message;
                  else msg = error;
                  this.showAlert('warning', 'Atención!', msg);
                })
                .finally(() => this.loadingAvailable = false);
          }
        }
      }
    },
    getUser() {
      const profile = sessionStorage.getItem('mccain_cuotas_user');
      if (profile) {
        const data = JSON.parse(profile);
        this.country = data.address.countryName;
        this.user = data.firstname + ' ' + data.lastname;
        this.admin_cuota = data?.admin_cuota === true;
      }
    },
    getCuotas(page = 1) {
      this.mostrarCarga();
      axios.get(`/cuotificador/cuotas?page=${page}${this.getFilterQuery()}`)
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            const cuotas = data.cuotas;
            if (this.country === 'Mexico' || this.country === 'Calatin') {
              this.cuotas = cuotas.map((cuota) => {
                cuota.start_date = cuota.start_date.substring(0, 10);
                cuota.final_date = cuota.final_date.substring(0, 10);
                return cuota;
              });
            }
            if (this.country === 'Argentina') {
              this.cuotas = cuotas.map((cuota) => {
                cuota.start_date = cuota.Fecha_inicio.substring(0, 10);
                cuota.final_date = cuota.Fecha_final.substring(0, 10);
                return cuota;
              });
            }
            this.ocultarCarga();
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.cuotas = [];
            this.showAlert('warning', 'Atención!', msg);
            this.ocultarCarga();
          });
    },
    getSkus() {
      this.loadingSku = true;
      let data = {};
      if (this.country === 'Argentina') {
        let filter = this.getFilterData();
        data = {
          "zone": filter.selectedZone
        }
      }
      axios.post('cuotificador/data/skus', data)
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.filterData.skus = data.skus;
            this.skuOptions = this.filterData.skus.map((sku) => ({
              value: sku.code, // Valor a usar en el v-model
              displayText: this.customLabelSku(sku), // Texto visible en el VueMultiselect
            }));
            this.ocultarCarga();
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.filterData.skus = [];
            this.skuOptions = [];
            this.showAlert('warning', 'Atención!', msg);
            this.ocultarCarga();
          })
          .finally(() => this.loadingSku = false);
    },
    getPlants() {
      this.loadingPlant = true;
      axios.get('cuotificador/data/plants')
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.filterData.plants = data.plants;
            this.plantOptions = this.filterData.plants.map((plant) => ({
              value: plant.plant_id, // Valor a usar en el v-model
              displayText: `${plant.plant_id} - ${plant.plant_name}`, // Texto visible en el VueMultiselect
            }));
            this.ocultarCarga();
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.filterData.plants = [];
            this.plantOptions = [];
            this.showAlert('warning', 'Atención!', msg);
            this.ocultarCarga();
          })
          .finally(() => this.loadingPlant = false);
    },
    getClients() {
      this.loadingClient = true;
      let data = {};
      if (this.country === 'Argentina') {
        let filter = this.getFilterData();
        data = {
          "zone": filter.selectedZone
        }
      }
      axios.post('cuotificador/data/clients', data)
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.filterData.clients = data.clients;
            this.clientOptions = this.filterData.clients.map((client) => {
              switch (this.country) {
                case 'Calatin':
                  return {
                    value: client.sold_to, // Valor a usar en el v-model
                    displayText: `${client.sold_to} - ${client.name_soldto}`, // Texto visible en el VueMultiselect
                  };
                default:
                  return {
                    value: client.cliente_codigo, // Valor a usar en el v-model
                    displayText: `${client.cliente_codigo} - ${client.cliente_nombre}`, // Texto visible en el VueMultiselect
                  };
              }
            });
            this.ocultarCarga();
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.filterData.clients = [];
            this.clientOptions = [];
            this.showAlert('warning', 'Atención!', msg);
            this.ocultarCarga();
          })
          .finally(() => this.loadingClient = false);
    },
    getZones() {
      this.loadingZone = true;
      axios.get('cuotificador/data/zones')
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.filterData.zones = data.zones;
            if (this.country === 'Mexico' || this.country === 'Calatin') {
              this.zoneOptions = this.filterData.zones.map((zone) => ({
                value: zone, // Valor a usar en el v-model
                displayText: `${zone}`, // Texto visible en el VueMultiselect
              }));
            }
            if (this.country === 'Argentina') {
              this.zoneOptions = this.filterData.zones.map((zona_nombre) => ({
                value: zona_nombre, // Valor a usar en el v-model
                displayText: zona_nombre.zona_nombre, // Texto visible en el VueMultiselect
              }));
            }
            this.ocultarCarga();
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.filterData.zones = [];
            this.zoneOptions = [];
            this.showAlert('warning', 'Atención!', msg);
            this.ocultarCarga();
          })
          .finally(() => this.loadingZone = false);
    },
    mostrarCarga() {
      $('.loading').removeClass('d-none');
      $('.loading').addClass('d-block');
      $('#mostrarTablas').addClass('d-none');
    },
    ocultarCarga() {
      $('.loading').removeClass('d-block');
      $('.loading').addClass('d-none');
      $('#mostrarTablas').removeClass('d-none');
    },
    showAlert(type, title, message) {
      this.$refs.alert.showAlert(
          type,
          message,
          title,
          {
            iconSize: 35,
            iconType: 'solid',
            position: 'top right'
          }
      );

      setTimeout(() => {
        this.$refs.alert.$el.style.display = 'none';
      }, 5000);  // 5 segundos y se borra
    },
    customLabelSku({code, name, material}) {
      return this.country === 'Mexico'
          ? `${material} - ${name} - ${code}`
          : `${code} - ${name} - ${material}`;
    },
    cleanFilter() {
      this.filter = {};
      this.getCuotas();
    },
    getFilterData() {
      let filterObject = JSON.parse(JSON.stringify(this.filter));

      if (filterObject.start_date !== undefined && filterObject.start_date !== null && !isNaN(Date.parse(filterObject.start_date))) {
        filterObject.start_date = (new Date(filterObject.start_date)).toISOString().split('T')[0];
      } else if (isNaN(Date.parse(filterObject.start_date))) filterObject.start_date = null;
      else filterObject.start_date = null;

      if (filterObject.final_date !== undefined && filterObject.final_date !== null && !isNaN(Date.parse(filterObject.final_date))) {
        filterObject.final_date = (new Date(filterObject.final_date)).toISOString().split('T')[0];
      } else if (isNaN(Date.parse(filterObject.final_date))) filterObject.final_date = null;
      else filterObject.final_date = null;

      if (filterObject.selectedClient !== undefined && filterObject.selectedClient !== null) {
        filterObject.selectedClient = this.filter.selectedClient.value;
      } else filterObject.selectedClient = null;

      if (filterObject.selectedZone !== undefined && filterObject.selectedZone !== null && this.country === 'Argentina') {
        filterObject.selectedZone = this.filter.selectedZone.value.zona_nombre;
      } else filterObject.selectedZone = null;

      if (filterObject.selectedZone !== undefined && filterObject.selectedZone !== null && (this.country === 'Mexico' || this.country === 'Calatin')) {
        filterObject.selectedZone = this.filter.selectedZone.value;
      }

      if (filterObject.selectedSku !== undefined && filterObject.selectedSku !== null) {
        filterObject.selectedSku = this.filter.selectedSku.value;
      } else filterObject.selectedSku = null;

      if (filterObject.selectedPlant !== undefined && filterObject.selectedPlant !== null) {
        filterObject.selectedPlant = this.filter.selectedPlant.value;
      } else filterObject.selectedPlant = null;

      return filterObject;
    },
    getFilterQuery() {
      const query = new URLSearchParams(this.getFilterData()).toString();
      return (query) ? `&${query}` : ``;
    },
    exportXlsx() {
      let url = process.env.VUE_APP_BACKEND_API_URL;
      url += `cuotificador/export?${this.getFilterQuery()}`;
      window.open(url, "_self");
    },
    exportReport() {
      let url = process.env.VUE_APP_BACKEND_API_URL;
      url += `cuotificador/report?${this.getFilterQuery()}`;
      window.open(url, "_self");
    },
    importXlsx() {
      if (!this.form.file) return;
      this.mostrarCarga();
      axios.post(`/cuotificador/import`, this.form, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        responseType: 'arraybuffer'
      })
          .then((response) => {
            let mime = 'application/vnd.ms-excel';
            let contentType = response.headers["content-type"] || mime;
            let blob = new Blob([response.data], {type: contentType});
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);

            let cd = response.headers["content-disposition"];
            let regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            let match = regex.exec(cd);
            let fileName = match[1] || "result.xlsx";

            link.download = fileName;
            link.click();

            this.form.file = null;
            this.getCuotas();
            this.showAlert('success', 'Atención!', `Archivo procesado.`);
          })
          .catch((error) => {
            let msg = '';
            if (error.code === 'ERR_BAD_REQUEST' && error.response?.status === 400) msg = 'Los encabezados son inválidos.';
            else msg = `Ocurrió un error al subir el archivo.`;
            this.form.file = null;
            this.showAlert('warning', 'Atención!', msg);
          })
          .finally(() => this.ocultarCarga());
    },
    openFileUploader() {
      document.getElementById('fileupload').click()
    },
    newCuota() {
      location.href = route + 'cuota-nueva';
    },
    verCuota(cuota) {
      this.mostrar_detalle = true;
      this.selectedCuota = cuota;
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    ocultarDetalle(variable) {
      this.mostrar_detalle = variable;
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.ocultarCarga();
    },
    updateCuota(cuota) {
      if (cuota.ID) {
        const index = this.cuotas.findIndex((c) => c.ID === cuota.ID);
        if (index >= 0) this.cuotas[index] = cuota;
      } else if (cuota.id) {
        const index = this.cuotas.findIndex((c) => c.id === cuota.id);
        if (index >= 0) this.cuotas[index] = cuota;
      }
    }
  }
}
</script>

<style>

.cuota-row {
  cursor: pointer;
}

.cuota-row:hover {
  background-color: #e8e8e8;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  width: auto;
  margin-top: 20px;
}

.spinner {
  border: 8px solid #f3f3f3; /* Light grey */
  border-top: 8px solid #ffc800; /* Blue */
  border-radius: 50%;
  width: auto;
  height: auto;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>